export type ApiMode = 'development' | 'production';

export function getApiMode(): ApiMode {
  const apiMode = import.meta.env.VITE_API_MODE;

  if (apiMode === 'development' || apiMode === 'production') {
    return apiMode;
  }

  return import.meta.env.MODE === 'development' ? 'development' : 'production';
}

export function isDev(): boolean {
  return getApiMode() === 'development';
}

export const isLocalhost =
  window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
